import useSWR from "swr";
import getBuyerAPIDomain from "../APICalls/getBuyerAPIDomain";

import { MappedFacetList } from "../Filters/filters.type";
import getFacetList from "../Filters/getFacetList";

export function useFacetList(
  isToUseAuthZero: boolean,
  accessToken: string | undefined
) {
  const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);
  const getFacetListUrl =
    buyerAPIDomain && (accessToken || !isToUseAuthZero)
      ? new URL(
          `${buyerAPIDomain.href}/saleresults/facets/configuration`,
          buyerAPIDomain
        )
      : null;

  const swrKey = getFacetListUrl
    ? [getFacetListUrl.href, accessToken, isToUseAuthZero]
    : null;

  const { data: facetListResult, error: facetListError } =
    useSWR<MappedFacetList>(swrKey, getFacetList, {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    });

  return { facetListResult, facetListError };
}

export default useFacetList;
